import * as types from '../mutation-types'
import acyearService from '../../services/acyears'

const state = {
    loading: false,
    errors: null,
    acyears: []
}

const actions = {
    getAll({ commit }) {
        commit(types.ACYEAR_LOADING, true)
        acyearService.getAll().then(
            response => {

                commit(types.LOAD_ACYEARS, response.data)
                commit(types.ACYEAR_LOADING, false)
                commit(types.ACYEAR_FAILURE, null)
            },
            error => {
                commit(types.ACYEAR_FAILURE, error)
                commit(types.ACYEAR_LOADING, false)
            }
        )
    },
    add({ commit }, data) {
        commit(types.ACYEAR_LOADING, true)
        commit(types.ACYEAR_FAILURE, null)
        acyearService.add(data).then(
            response => {
                //console.log('responseooo', response)
                data.id = response.data.id
                data.status = 1
                commit(types.ADD_ACYEAR, data)
                commit(types.ACYEAR_LOADING, false)

            },
            error => {
                commit(types.ACYEAR_FAILURE, error)
                commit(types.ACYEAR_LOADING, false)
            }
        )
    },
    update({ commit }, data) {
        commit(types.ACYEAR_LOADING, true)
        commit(types.ACYEAR_FAILURE, null)
        acyearService.update(data.acyear)
            .then(
                response => {
                    commit(types.UPDATE_ACYEAR, data)
                    commit(types.ACYEAR_LOADING, false)

                },
                error => {
                    commit(types.ACYEAR_FAILURE, error)
                    commit(types.ACYEAR_LOADING, false)
                }
            )


    },
    delete({ commit }, data) {
        commit(types.ACYEAR_LOADING, true)
        commit(types.ACYEAR_FAILURE, null)
        acyearService.delete(data.acyear.id)
            .then(
                response => {

                    commit(types.DELETE_ACYEAR, data)
                    commit(types.ACYEAR_LOADING, false)

                },
                error => {
                    commit(types.ACYEAR_FAILURE, error)
                    commit(types.ACYEAR_LOADING, false)
                }
            )
    }
}

const mutations = {
    [types.ADD_ACYEAR](state, payload) {
        state.acyears.unshift(payload);
    },
    [types.LOAD_ACYEARS](state, payload) {
        state.acyears = payload
    },
    [types.UPDATE_ACYEAR](state, payload) {
        Object.assign(state.acyears[payload.index], payload.acyear);
    },
    [types.DELETE_ACYEAR](state, payload) {
        state.acyears.splice(payload.index, 1)
    },
    [types.ACYEAR_FAILURE](state, payload) {
        state.errors = payload
    },

    [types.ACYEAR_LOADING](state, payload) {
        state.loading = payload
    },
}
const getters = {
    ACYEARS: state => {
        return state.acyears
    },

    ACYEAR_ERROR: state => {
        return state.errors
    },

    ACYEAR_LOADING: state => {
        return state.loading
    }
}


export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/academicYear.js